import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-34b46f94")

_pushScopeId("data-v-34b46f94")
const _hoisted_1 = { class: "RandomQuoteBtn" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "btn-text" }, "Random", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "material-icons-outlined btn-icon" }, "loop", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
    }, [
      _hoisted_2,
      _hoisted_3
    ])
  ]))
})